import LogicException   from '../errors/LogicException'
import { FieldTypes }   from '../field-types'
import FormElementTypes from '../FormElementTypes'

export default class {

  /**
   *
   * @param response - response z API::GetEntityDefinition
   */
  constructor (response) {
    this._response = response

    if (!this.response || !this.response.data.length) {
      throw new LogicException('Response is not valid format!!')
    }

    this._data = this._response.data[0]

    const readonly = this._data.hasOwnProperty('IsReadOnly')
      ? this._data.IsReadOnly
      : 'disable'

    this._code              = this._data.Code
    this._idtEntity         = this._data.idtEntity
    this._viewName          = this._data.ViewName
    this._field             = this._data.Field
    this._list              = this._data.List
    this._idtEStrctr        = this._data.idtEntityStructureFrom
    this._dictionaryKeyCode = this._data.DictionaryKeyCode
    this._headers            = this._data.Headers
    this._editor            = this._data.Editor
    this._isReadOnly        = readonly
    this._newRec            = this._data.NewRec
    this._valRec            = this._data.ValRec
    this._calRec            = this._data.CalRec
    this._delRec            = this._data.DelRec
    this._afterSaveRec      = this._data.AfterSaveRec
    this._orderBy           = this._data.OrderBy
    this._whereCondition    = this._data.WhereCondition
    this._interpretation    = this._data.hasOwnProperty('Interpretation')
      ? this._data.Interpretation
      : undefined

    this._dataFilters = []

    this._filterDefinition()
  }

  /**
   *
   * @private
   */
  _initColumns () {
    this._filtredGrid       = []
    this._filteredEditor    = []
    this._icons             = []
    this._images            = []
    this._editorIcons       = []
    this._editorImages      = []
    this._listForms         = []
    this._listButtons       = []
    this._editorButtons     = []
    this._editorMenuButtons = []
    this._documents         = []
    this._subForms          = []
  }

  /**
   *
   * @private
   */
  _filterDefinition () {
    this._initColumns()

    if (this.list) {
      for (let i = 0; i < this._list.length; i++) {
        if (this._list[i].FieldType === 'ICON') {
          this._icons.push(this._list[i])

          continue
        }

        if (this._list[i].FieldType === 'IMAGE') {
          this._images.push(this._list[i])

          continue
        }

        if (this._list[i].FieldType === FormElementTypes.enuFormAction) {
          this._listButtons.push(this._list[i])

          continue
        }

        if (
          (this._list[i].FieldType === 'COUNTER' &&
            this._list[i].Interpretation === 'Counter')
        ) {
          this._listForms.push(this._list[i])

          continue
        }

        if (this._list[i].FieldType === FieldTypes.document ||
          this._list[i].FieldType === FieldTypes.signature) {
          this._documents.push(this._list[i])
        }

        this._filtredGrid.push(this._list[i])
      }
    }

    if (this.editor) {
      masterLoop:
        for (let i = 0; i < this._editor.length; i++) {
          for (const keyFilter in this._dataFilters) {
            if (keyFilter.includes(this._editor[i].Code.toUpperCase())) {
              if (parseInt(this._dataFilters[keyFilter]) === 2) {
                continue masterLoop
              }
              if (parseInt(this._dataFilters[keyFilter]) === 1) {
                this._editor[i].IsReadOnly = 'true'
              }
              if (parseInt(this._dataFilters[keyFilter]) === 0) {
                this._editor[i].IsReadOnly = false
              }
            }
          }

          if (this._editor[i].FieldType === 'ICON') {
            this._editorIcons.push(this._editor[i])

            continue
          }

          if (this._editor[i].FieldType === 'IMAGE') {
            this._editorImages.push(this._editor[i])

            continue
          }

          if (this._editor[i].FieldType === FormElementTypes.enuFormAction) {
            this._editorButtons.push(this._editor[i])

            continue
          }

          if (this._editor[i].FieldType === FormElementTypes.enuFormMenu) {
            buttonMasterLoop:
              for (const menuButtonDef of this._editor[i].Fields) {
                if (!menuButtonDef.hasOwnProperty('IsReadOnly')) {
                  menuButtonDef['IsReadOnly'] = 'false'
                }

                for (const keyFilterButton in this._dataFilters) {
                  if (keyFilterButton.includes(
                    menuButtonDef.Code.toUpperCase())) {
                    if (parseInt(this._dataFilters[keyFilterButton]) === 2) {
                      continue buttonMasterLoop
                    }
                    if (parseInt(this._dataFilters[keyFilterButton]) === 1) {
                      menuButtonDef.IsReadOnly = 'true'
                    }
                    if (parseInt(this._dataFilters[keyFilterButton]) === 0) {
                      menuButtonDef.IsReadOnly = false
                    }
                  }
                }

                this._editorMenuButtons.push(menuButtonDef)
              }

            continue
          }

          if (this._editor[i].FieldType === FormElementTypes.enuEntForm) {
            if (this._editor[i].Interpretation === 'MasterSlave' ||
              this._editor[i].Interpretation === 'Gallery') {
              continue
            }

            this._subForms.push(this._editor[i])
          }

          this._filteredEditor.push(this._editor[i])
        }
    }
  }

  filterByData (data) {
    for (const key in data) {
      if (key.includes('VS_')) {
        this._dataFilters[key] = data[key]
      }
    }

    this._filterDefinition()
  }

  get dataFilters () {
    return this._dataFilters
  }

  /**
   *
   * @return {ui.autocomplete._response|*}
   */
  get response () {
    return this._response
  }

  /**
   *
   * @returns {*}
   */
  get code () {
    return this._code
  }

  /**
   *
   * @return {*}
   */
  get viewName () {
    return this._viewName
  }

  /**
   *
   * @return {*}
   */
  get editor () {
    return this._editor
  }

  /**
   * @return {*|List}
   */
  get list () {
    return this._list
  }

  /**
   * @return {*|List}
   */
  get filteredGrid () {
    return this._filtredGrid
  }

  /**
   * @return {*|List}
   */
  get filteredEditor () {
    return this._filteredEditor
  }

  /**
   *
   * @return {Array}
   */
  get listIcons () {
    return this._icons
  }

  /**
   *
   * @return {Array}
   */
  get listDocuments () {
    return this._documents
  }

  /**
   *
   * @return {Array}
   */
  get listImages () {
    return this._images
  }

  /**
   *
   * @return {Array}
   */
  get editorIcons () {
    return this._editorIcons
  }

  /**
   *
   * @return {Array}
   */
  get editorImages () {
    return this._editorImages
  }

  /**
   *
   * @return {Array}
   */
  get editorButtons () {
    return this._editorButtons
  }

  /**
   * @return {Array}
   */
  get editorMenuButtons () {
    return this._editorMenuButtons
  }

  /**
   *
   * @return {Array}
   */
  get listForms () {
    return this._listForms
  }

  /**
   *
   * @return {Array}
   */
  get listButtons () {
    return this._listButtons
  }

  /**
   *
   * @return {*}
   */
  get dictionaryKeyCode () {
    return this._dictionaryKeyCode
  }

  /**
   *
   * @return {*}
   */
  get idtEStrctr () {
    return this._idtEStrctr
  }

  /**
   *
   * @return {*}
   */
  get field () {
    return this._field
  }

  /**
   *
   * @return {*}
   */
  get delRec () {
    return this._delRec
  }

  /**
   *
   * @return {*}
   */
  get calRec () {
    return this._calRec
  }

  /**
   *
   * @return {*}
   */
  get valRec () {
    return this._valRec
  }

  /**
   *
   * @return {*}
   */
  get newRec () {
    return this._newRec
  }

  /**
   *
   * @return {null|*}
   */
  get afterSaveRec () {
    return this._afterSaveRec
  }

  /**
   *
   * @return {*}
   */
  get isReadOnly () {
    return this._isReadOnly
  }

  /**
   *
   * @return {*}
   */
  get interpretation () {
    return this._interpretation
  }

  /**
   *
   * @return {null|*}
   */
  get idtEntity () {
    return this._idtEntity
  }

  /**
   *
   * @return {*}
   */
  get orderBy () {
    return this._orderBy
  }

  /**
   *
   * @return {*}
   */
  get whereCondition () {
    return this._whereCondition
  }

  /**
   *
   * @return {*}
   */
  get subForms () {
    return this._subForms
  }

  /**
   *
   * @param id
   */
  replaceWhereCondition (id) {
    if (!this.whereCondition) {
      return
    }

    this._whereCondition = this._data.WhereCondition.replace('%ID%', id)
  }

  /**
   *
   * @param id
   * @returns {string}
   */
  getReplacedWhereCondition (id) {
    if (!this.whereCondition) {
      return
    }

    const condition = this._data.WhereCondition

    return condition.replace('%ID%', id)
  }

  getEditorIcons (data) {
    const icons = []

    this.editorIcons.forEach((s) => {
      if (!data.hasOwnProperty(s.ColumnName)) {
        return false
      }

      let value = null
      try {
        value = JSON.parse(data[s.ColumnName])
      }
      catch (e) {
        return false
      }

      icons.push({ def: s, value: value })
    })

    return icons
  }
}
